import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import VisibilitySensor from 'react-visibility-sensor'

import logo_ga from '../../images/png/home/integrations/ga.png'
import logo_hs from '../../images/png/home/integrations/hs.png'
import logo_sf from '../../images/png/home/integrations/sf.png'
import logo_marketo from '../../images/png/home/integrations/marketo.png'
import logo_zapier from '../../images/png/home/integrations/zapier.png'

import img1 from '../../images/png/home/integrations/graphs/image1.png'
import img2 from '../../images/png/home/integrations/graphs/image2.png'
import img3 from '../../images/png/home/integrations/graphs/image3.png'
import img4 from '../../images/png/home/integrations/graphs/image4.png'
import img5 from '../../images/png/home/integrations/graphs/image5.png'
import img6 from '../../images/png/home/integrations/graphs/image6.png'
import img7 from '../../images/png/home/integrations/graphs/image7.png'
import img8_1 from '../../images/png/home/integrations/graphs/image8-1.png'
import img8_2 from '../../images/png/home/integrations/graphs/image8-2.png'

const IntegrationsBlock = ({ t }) => {
    const [done, setDone] = useState(false)
    const [width, setWidth] = useState(100)

    function onChange(isVisible) {
        if (isVisible && !done) {
            setDone(true)
            setWidth(22)
        }
    }

    return (
        <div className="home__integrations-block">
            <h3 className="dark">{t('_pages._home._integrations_block.title')}</h3>
            <p>{t('_pages._home._integrations_block.subtitle')}</p>
            <ul className="logos">
                <li className="logo">
                    <img src={logo_ga} alt="" />
                </li>
                <li className="logo">
                    <img src={logo_hs} alt="" />
                </li>
                <li className="logo">
                    <img src={logo_sf} alt="" />
                </li>
                <li className="logo">
                    <img src={logo_marketo} alt="" />
                </li>
                <li className="logo">
                    <img src={logo_zapier} alt="" />
                </li>
                <li className="logo">{t('_pages._home._integrations_block.and_more')}</li>
            </ul>

            <ul className="graphs">
                <li className="graph graph--img graph--img--1">
                    <img src={img1} alt="" />
                </li>
                <li className="graph graph--html graph--html--1">
                    <img src={img8_1} alt="" id="img1" />
                    <VisibilitySensor onChange={onChange} partialVisibility={true}>
                        <div className="box">
                            <div className="band" style={{ width: `${width}%` }}></div>
                        </div>
                    </VisibilitySensor>
                    <img src={img8_2} alt="" id="img2" />
                </li>
                <li className="graph graph--img graph--img--2">
                    <img src={img4} alt="" />
                </li>
                <li className="graph graph--img graph--img--3">
                    <img src={img2} alt="" />
                </li>
                <li className="graph graph--img graph--img--4">
                    <img src={img3} alt="" />
                </li>
                <li className="graph graph--img graph--img--5">
                    <img src={img5} alt="" />
                </li>
                <li className="graph graph--img graph--img--6">
                    <img src={img6} alt="" />
                </li>
                <li className="graph graph--img graph--img--7">
                    <img src={img7} alt="" />
                </li>
            </ul>
        </div>
    )
}

export default withTranslation('translations')(IntegrationsBlock)
